import React from 'react';
import { Typography, List, ListItem, ListItemText, Divider } from '@mui/material';

import Page from './Page';
import Header from './Header';

const Terms = () => {
  const sections = [
    {
      title: 'Rental Window',
      body: 'Standard rentals cover 3 calendar days beginning on the arrival date shown in checkout. Additional days can be added in the calendar selector and will be billed according to weekday, weekend or holiday rates.'
    },
    {
      title: 'Shipping & Returns',
      body: 'DIY Casino Party covers outbound shipping. Customers are responsible for dropping the prepaid return package with the listed carrier on or before the scheduled return date. Late returns may incur a daily fee equal to the weekday rate.'
    },
    {
      title: 'Security Deposit',
      body: 'A fully refundable security deposit may appear on your statement for high-volume orders. Deposits are released within 2 business days after the cloth is scanned by the carrier.'
    },
    {
      title: 'Damage Policy',
      body: 'Normal wear is included. Severe damage, tears or burns will be billed at the replacement value of the specific cloth. Please avoid permanent markers, wax and open flames near the fabric.'
    },
    {
      title: 'Cancellations',
      body: 'Orders cancelled at least 10 days before the ship date receive a full refund. Orders cancelled within 9 days are eligible for a 50% rental credit. Once an order is in transit it cannot be cancelled.'
    }
  ];

  return (
    <Page>
      <Header text="Terms & Policies" subHeader="Please review before submitting your order" />
      <List>
        {sections.map(section => (
          <React.Fragment key={section.title}>
            <ListItem alignItems="flex-start">
              <ListItemText
                primary={<Typography variant="h4">{section.title}</Typography>}
                secondary={<Typography variant="body1">{section.body}</Typography>}
              />
            </ListItem>
            <Divider component="li" />
          </React.Fragment>
        ))}
      </List>
    </Page>
  );
};

export default Terms;
